<template>
  <div>
    <b-card v-if="listarEmpresas">
      <div slot="header"><strong>Documentos</strong></div>
      <b-row>
        <b-col lg="5" md="6" sm="8">
          <b-row>
            <b-col lg="10" md="8" sm="12" xs="12">
              <b-form-group label="Empresa" horizontal="">
                <el-select
                  v-model="selectedDocumentos.empresa"
                  filterable
                  remote
                  no-data-text="No matching data"
                  no-match-text="No matching data"
                  :remote-method="buscarEmpresa"
                  translate="no"
                >
                  <el-option
                    v-for="item in listaEmpresas"
                    :key="item.id"
                    :label="item.nombre"
                    :value="item.id"
                    translate="no"
                  ></el-option>
                </el-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="5" md="6" sm="8">
          <b-row>
            <b-col lg="10" md="8" sm="12" xs="12">
              <b-form-group label="Buscar archivo o folder" horizontal="">
                <el-select
                  v-model="document_id"
                  filterable
                  remote
                  no-data-text="No matching data"
                  no-match-text="No matching data"
                  :remote-method="searchDocument"
                  @change="changeSelectedDocumentAction"
                  translate="no"
                >
                  <el-option
                    v-for="item in documents"
                    :key="item.id"
                    :label="item.descripcion"
                    :value="item.id"
                    translate="no"
                  >
                    <i class="fa " :class="{ 'fa-folder': item.tipo === 'folder', 'fa-file': item.tipo === 'file'}"></i><span> {{ item.descripcion }}</span>
                  </el-option>
                </el-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr>
      <b-row v-if="selectedDocumentos.treeVisible">
        <b-col lg="2" md="2" sm="12"></b-col>
        <b-col lg="10" md="10" sm="12" xs="12">
          <VJstree
            :data="treeInfo"
            show-checkbox
            collapse
            size="large"
            @item-click="treeItemClick"
            translate="no"
          >
            <template slot-scope="_">
              <div style="display: inherit; width: 200px;">
                <i
                  :class="_.vm.themeIconClasses"
                  :style="colorFolder(_.model)"
                  role="presentation"
                  v-if="!_.model.loading"
                ></i>
                {{ _.model.text }}
                <button
                  v-b-tooltip.hover
                  title="Editar"
                  style="
                    border: 0px;
                    background-color: transparent;
                    cursor: pointer;
                    color: #2fa8d8;
                  "
                  @click="editFile(_.vm, _.model, $event)"
                >
                  <i class="fa fa-pencil-square-o"></i>
                </button>
                <button
                  v-b-tooltip.hover
                  title="Descargar archivo"
                  style="
                    border: 0px;
                    background-color: transparent;
                    cursor: pointer;
                    color: #4dbd74;
                  "
                  v-if="_.model.type == 'file'"
                  @click="downloadFile(_.vm, _.model, $event)"
                >
                  <i class="fa fa-download"></i>
                </button>
                <button
                  v-b-tooltip.hover
                  title="Adjuntar archivo"
                  style="
                    border: 0px;
                    background-color: transparent;
                    cursor: pointer;
                    color: #227b83;
                  "
                  v-if="_.model.type != 'file'"
                  @click="adjuntar"
                >
                  <i class="fa fa-cloud-upload"></i>
                </button>
                <button
                  v-b-tooltip.hover
                  title="Eliminar"
                  style="
                    border: 0px;
                    background-color: transparent;
                    cursor: pointer;
                    color: #f76c6c;
                  "
                  v-if="_.model.activo == 1"
                  @click="deleteFile(_.vm, _.model, $event)"
                >
                  <i class="fa fa-trash"></i>
                </button>
                <button
                  v-b-tooltip.hover
                  title="Activar"
                  style="
                    border: 0px;
                    background-color: transparent;
                    cursor: pointer;
                    color: #1f487b;
                  "
                  v-if="_.model.activo == 0"
                  @click="activeFile(_.vm, _.model, $event)"
                >
                  <i class="fa fa-check"></i>
                </button>
              </div>
            </template>
          </VJstree>
        </b-col>
      </b-row>
      <b-row
        v-if="
          selectedDocumentos.empresa != null &&
          selectedDocumentos.empresa != '' &&
          selectedDocumentos.treeVisible == true &&
          treeInfo.length == 0
        "
      >
        <b-col lg="4" md="4" sm="12" xs="12"></b-col>
        <b-col lg="4" md="4" sm="12" xs="12">
          <b-card>
            <div>
              No existen documentos.
              <br />
              Para crear una carpeta donde incluirá archivos haga click en el
              botón
              <b>
                <i class="fa fa-folder"></i>
                Crear carpeta
              </b>
            </div>
          </b-card>
        </b-col>
        <b-col lg="4" md="4" sm="12" xs="12"></b-col>
      </b-row>
      <hr v-if="selectedDocumentos.treeVisible" />
      <b-row v-if="selectedDocumentos.treeVisible">
        <b-col lg="2" md="2" sm="12" xs="12"></b-col>
        <b-col lg="8" md="8" sm="12" xs="12">
          <b-button variant="success" @click="crearCarpeta" v-if="btnCarpeta">
            <i class="fa fa-folder"></i>
            Crear carpeta
          </b-button>
          &nbsp;
          <b-button variant="info" ref="btnrefresh" @click="getArbolEmpresa">
            <i class="fa fa-refresh"></i>
            Actualizar
          </b-button>
        </b-col>
        <b-col lg="2" md="2" sm="12" xs="12"></b-col>
      </b-row>
    </b-card>

    <div v-else>
      <b-card style="width: 100%;">
        <div slot="header"><strong>Documentos</strong></div>
        <b-row v-if="selectedDocumentos.treeVisible">
          <b-col lg="2" md="2" sm="12"></b-col>
          <b-col lg="10" md="10" sm="12" xs="12">
            <VJstree
              :data="treeInfo"
              collapse
              size="large"
              @item-click="treeItemClick"
            >
              <template slot-scope="_">
                <div style="display: inherit; width: 200px;">
                  <i
                    :class="_.vm.themeIconClasses"
                    role="presentation"
                    :style="colorFolder(_.model)"
                    v-if="!_.model.loading"
                  ></i>
                  {{ _.model.text }}
                  <button
                    style="
                        border: 0px;
                        background-color: transparent;
                        cursor: pointer;
                        color: #4dbd74;
                    "
                    @click="downloadFile(_.vm, _.model, $event)"
                    v-if="_.model.type == 'file'"
                  >
                    <i class="fa fa-download"></i>
                  </button>
                </div>
              </template>
            </VJstree>
          </b-col>
        </b-row>
        <b-row v-if="treeInfo.length == 0">
          <b-col lg="4" md="4" sm="12" xs="12"></b-col>
          <b-col lg="4" md="4" sm="12" xs="12">
            <b-card>
              <div>
                Para ver los archivos da click en <strong>Actualizar</strong>,
                si por algun motivo no te salen y crees que es un error,
                comuniquese con Mejora y Soluciones SAS para validar.
              </div>
            </b-card>
            <center>
              <b-button variant="primary" @click="getArbolEmpresa()">
                <i class="fa fa-refresh"></i>
                Actualizar
              </b-button>
            </center>
          </b-col>
          <b-col lg="4" md="4" sm="12" xs="12"></b-col>
        </b-row>
      </b-card>
    </div>

    <b-modal
      size="md"
      :title="
        selectedDocumentos.adjuntar == true
          ? 'Adjuntar documento'
          : 'Cambiar nombre'
      "
      ref="modalAdjuntarDoc"
      :hide-footer="true"
    >
      <Adjuntar
        :empresa="selectedDocumentos.empresa"
        :padre="selectedDocumentos.nodeActiveId"
        :editar="selectedDocumentos.modifyNode"
        :modalAttachmentRef="$refs.modalAdjuntarDoc"
        :companies="listaEmpresas"
        :seletedItem="seletedItem"
      ></Adjuntar>
    </b-modal>
    <b-modal
      size="md"
      title="Crear carpeta"
      ref="modalCrearCarp"
      :hide-footer="true"
    >
      <Carpeta
        :empresa="selectedDocumentos.empresa"
        :padre="selectedDocumentos.nodeActiveId"
        :node="selectedDocumentos.nodeToModify"
        @closeModalCrear="$refs.modalCrearCarp.hide()"
      ></Carpeta>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import {
  getAcls,
  validarPermisoComponente,
  validarRol,
} from '../../../plugins/acl'
import VJstree from 'vue-jstree'
import Adjuntar from './Adjuntar'
import Carpeta from './Carpeta'
import Swal from 'sweetalert2'

export default {
  name: 'DocumentosEmpresa',
  data: function () {
    return {
      searchText: '',
      document_id: null,
      listarEmpresas: false,
      esEmpresa: false,
      listaEmpresas: [],
      seletedItem: null
    }
  },
  async created() {
    const acls = getAcls()
    let permiso = validarPermisoComponente('listar-empresas-asignadas')
    let permiso2 = !validarRol('empresa-contratista')
    this.limpiaEmpresa()
    if (permiso && permiso2) {
      this.listarEmpresas = true
      await this.getEmpresaFiltro()
    } else {
      this.selectedDocumentos.empresa = acls.empresa
    }
  },
  computed: {
    ...mapState('documentosEmpresa', [
      'selectedDocumentos',
      //'empresas',
      'treeInfo',
      'btnAdjuntar',
      'btnCarpeta',
      'urlDescarga',,
      'documents'
    ]),
    ...mapState('productos', ['selectedEmpresas']),
  },
  components: {
    VJstree,
    Adjuntar,
    Carpeta,
  },
  events: {
    eGetTreeEmpresa(e) {
      var elem = this.$refs.btnrefresh
      elem.click()
    },
  },
  methods: {
    ...mapActions('productos', ['getEmpresaFiltro']),
    ...mapActions('documentosEmpresa', [
      'getTreeEmpresa',
      'eliminaNodo',
      'descargarDocumento',
      'eliminaDocumento',
      'searchDocument',
      'changeSelectedDocument'
    ]),
    ...mapMutations('documentosEmpresa', [
      'limpiarNode',
      'limpiaEmpresa',
      'limpiarCampos',
    ]),
    async changeSelectedDocumentAction() {
        const companyDocument = this.documents.find(e=>e.id===this.document_id);
        await this.changeSelectedDocument(companyDocument);
    },
    async buscarEmpresa(query) {
      if (query.length >= 3) {
        setTimeout(() => {
          this.loading = true
          this.listaEmpresas = this.selectedEmpresas.empresas.filter((item) => {
            return item.nombre.toLowerCase().indexOf(query.toLowerCase()) > -1
          })
          this.loading = false
        }, 200)
      } else {
        this.listaEmpresas = []
      }
    },
    async vistaEmpresa() {
      await this.getArbolEmpresa()
    },
    async getArbolEmpresa() {
      this.selectedDocumentos.nodeActiveId = null
      this.loading = true
      await this.getTreeEmpresa(this.selectedDocumentos.empresa)
      this.loading = false
      this.treeInfo.forEach((element) => {
        this.selectedDocumentos.Informationtree.push(element)
      })
      this.selectedDocumentos.treeVisible = true
    },
    treeItemClick(node) {
      if (node.model.selected) {
        this.selectedDocumentos.nodeActiveId = node.model.id
      } else {
        this.selectedDocumentos.nodeActiveId = null
      }
    },
    adjuntar() {
      this.selectedDocumentos.tipo = 'file'
      this.selectedDocumentos.adjuntar = true
      this.selectedDocumentos.modifyNode = false
      this.selectedDocumentos.nodeToModify = {}
      this.limpiarCampos()
      this.$refs.modalAdjuntarDoc.show()
    },
    editFile(node) {
      this.seletedItem = node.data
      this.selectedDocumentos.adjuntar = false
      this.selectedDocumentos.nodeActiveId = node.data.id
      this.selectedDocumentos.modifyNode = true
      this.selectedDocumentos.nodeToModify = node.data
      this.limpiarCampos()
      this.selectedDocumentos.tipo = node.data.type
      this.$refs.modalAdjuntarDoc.show()
    },
    crearCarpeta() {
      this.selectedDocumentos.tipo = 'folder'
      this.selectedDocumentos.modifyNode = false
      this.selectedDocumentos.nodeToModify = {}
      this.$refs.modalCrearCarp.show()
    },
    async downloadFile(node) {
      this.selectedDocumentos.empresaId = this.selectedDocumentos.empresa

      await this.descargarDocumento(node.data)
    },
    async deleteFile(vm, model, e) {
      this.selectedDocumentos.empresaId = this.selectedDocumentos.empresa
      let confirmaText = ''
      if (model.type == 'folder') {
        confirmaText =
          '¿Está seguro de eliminar esta carpeta? todo su contenido será inaccesible'
      } else if (model.type == 'file') {
        confirmaText =
          '¿Está seguro de eliminar este archivo? será inaccesible'
      }
      Swal.fire({
        title: 'Confirmación',
        text: confirmaText,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si',
        cancelButtonText: 'Cancelar',
      }).then(async (result) => {
        if (result.isConfirmed) {
          model.activo = 0
          await this.eliminaNodo(model)
        }
      })
    },
    async deleteDocumento(vm, model, e) {
      let formato
      let formatoMensaje

      if (model.type == 'folder') {
        formato = 'Carpeta'
        formatoMensaje = 'la carpeta'
      } else {
        formato = 'Documento'
        formatoMensaje = 'el documento'
      }
      Swal.fire({
        title: `Eliminar ${formato}`,
        text:
          '¿Está seguro de eliminar ' +
          formatoMensaje +
          ' ' +
          model.text +
          ' ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, Eliminiar',
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.loading = true
          await this.eliminaDocumento(model.id)
          await this.getArbolEmpresa()
          this.loading = false
        }
      })
    },
    async activeFile(vm, model, e) {
      this.selectedDocumentos.empresaId = this.selectedDocumentos.empresa

      let confirmaText = ''
      if (model.type == 'folder') {
        confirmaText = '¿Está seguro de activar esta carpeta?'
      } else if (model.type == 'file') {
        confirmaText = '¿Está seguro de activar este archivo?'
      }
      Swal.fire({
        title: 'Confirmación',
        text: confirmaText,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si',
        cancelButtonText: 'Cancelar',
      }).then(async (result) => {
        if (result.isConfirmed) {
          model.activo = 1
          await this.eliminaNodo(model)
        }
      })
    },

    colorFolder(model) {
      if (model.type == 'folder') {
        return 'color: #dcc156'
      } else {
        return 'color: #f37a03'
      }
    },
  },
  watch: {
    'selectedDocumentos.empresa'(val) {
      if (val == null || val == '') {
        this.selectedEmpresas.empresas = []
      } else {
        this.selectedDocumentos.treeVisible = true
        this.getArbolEmpresa()
      }
    },
  },
}
</script>

<style>
.el-input__inner {
  height: 32px;
}

.el-date-editor .el-range-separator {
  line-height: 25px;
  width: 10%;
}

.el-date-editor--monthrange.el-input,
.el-date-editor--monthrange.el-input__inner {
  width: 100%;
}

.el-select {
  width: 100%;
}

.theme-ravenclaw {
  --fa-secondary-opacity: 1;
  --fa-primary-color: rgb(4, 56, 161);
  --fa-secondary-color: rgb(108, 108, 108);
}
</style>
